<template>
  <v-container fluid class="px-0">
    <div class="salesorder-page">
      <v-row>
        <v-col cols="12" md="12">
          <v-card>
            <v-card-text>
              <v-row class="ma-1">
                <v-col cols="12" md="4">
                  <p class="rhead">
                    {{ initvalue.salesordertype }} {{ initvalue.salesordernum }}
                  </p>
                </v-col>
                <v-spacer></v-spacer>
                <v-col cols="12" md="2" align="right">
                    <v-btn
                      class="button-shadow mr-1"
                        @click="Done"
                        replace
                        color="primary"
                      >
                        Done
                    </v-btn>
                </v-col>
              </v-row>
              <v-row class="ma-1">
                <v-col cols="12" md="4">
                  <p class="two-line">
                    <table width="100%">
                      <tr>
                        <td class="thead">Order Num</td>
                        <td>{{ initvalue.salesordernum }}</td>
                      </tr>
                      <tr>
                        <td class="thead">Order Date</td>
                        <td>{{ new Date(initvalue.salesorderdate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) }}</td>
                      </tr>
                      <tr>
                        <td class="thead">Due Date</td>
                        <td>{{ new Date(initvalue.salesorderduedate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) }}</td>
                      </tr>
                      <tr>
                        <td class="thead">Status</td>
                        <td>{{ initvalue.salesorderstatus }}</td>
                      </tr>
                    </table>
                  </p>
                </v-col>
                <v-col cols="12" md="5">
                  <p class="two-line">
                    <table width="100%">
                      <tr>
                        <td class="thead">Name</td>
                        <td>{{ initvalue.salesordername }}</td>
                      </tr>
                      <tr>
                        <td class="thead">Address</td>
                        <td>{{ initvalue.salesorderaddress }}</td>
                      </tr>
                      <tr>
                        <td class="thead">Phone</td>
                        <td>{{ initvalue.salesorderphone }}</td>
                      </tr>
                      <tr>
                        <td class="thead">Mobile</td>
                        <td>{{ initvalue.salesordermobile }}</td>
                      </tr>
                    </table>
                  </p>
                </v-col>
                <v-col cols="12" md="3">
                  <p class="two-line">
                    <table width="100%">
                      <tr>
                        <td class="thead">Total</td>
                        <td>{{ data_total.toFixed(2) }}</td>
                      </tr>
                      <tr>
                        <td class="thead">Received</td>
                        <td>{{ data_deposits.toFixed(2) }}</td>
                      </tr>
                      <tr>
                        <td class="thead">Balance</td>
                        <td>{{ (data_total - data_deposits).toFixed(2) }}</td>
                      </tr>
                    </table>
                  </p>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col md="12" cols="12" class="pt-0 pt-sm-3">
          <v-row>
            <v-col cols="12">
              <v-card class="folder-card ma-1" min-height="282">
                <v-card-text class="pa-5 pt-0">

                  <v-tabs color="secondary">
                    <v-tabs-slider></v-tabs-slider>
                    <v-tab
                      class="text-capitalize font-weight-regular"
                      :key="1"
                      :href="'#tab-items'"
                    >
                      Items
                    </v-tab>
                    <v-tab
                      class="text-capitalize font-weight-regular"
                      :key="2"
                      :href="'#tab-deposits'"
                    >
                      Deposits
                    </v-tab>
                    <v-tab
                      class="text-capitalize font-weight-regular"
                      :key="3"
                      :href="'#tab-files'"
                    >
                      Files
                    </v-tab>
                    <v-tab-item
                      :key="1"
                      :value="'tab-items'"
                      class="pb-0 pb-sm-3 pb-lg-0"
                    >
                      <v-divider></v-divider>
                      <v-row
                        justify-xl="space-around"
                        justify="start"
                        class="d-flex flex-nowrap overflow-x-auto pa-4 pt-5"
                      >
                        <v-col cols="12" md="12" sm="12">
                          <v-data-table
                            :loading="isReceiving"
                            item-key="_id"
                            :footer-props="footer"
                            :headers="header_items"
                            :items="transactions"
                            :items-per-page="itemPerPage">
                            <template v-slot:item.itemimage="{ item }">
                              <v-img
                              v-if="item.itemimage" 
                              v-bind:src="item.itemimage"
                              max-height="100"
                              max-width="100"
                            ></v-img>
                            </template>
                            <template v-slot:item.itemamount="{ item }">
                              <p class="two-line">{{ item.itemamount.toFixed(2) }}</p>
                            </template>
                          </v-data-table>
                        </v-col>
                      </v-row>
                    </v-tab-item>
                    <v-tab-item
                      :key="2"
                      :value="'tab-deposits'"
                      class="pb-0 pb-sm-3 pb-lg-0"
                    >
                      <v-divider></v-divider>
                      <v-row
                        justify-xl="space-around"
                        justify="start"
                        class="d-flex flex-nowrap overflow-x-auto pa-4 pt-5"
                      >
                        <v-col cols="12" md="12" sm="12">
                          <v-data-table
                            loading-text="Loading... Please wait"
                            item-key="_id"
                            :footer-props="footer"
                            :headers="header_deposits"
                            :items="deposits"
                            :items-per-page="itemPerPage">
                            <template v-slot:item.transdesc="{ item }">
                              <p v-if="item.transdesc!=null" class="two-line"><strong>{{ item.transdesc }}:</strong></p>
                            </template>
                            <template v-slot:item.transdate="{ item }">
                              <p v-if="item.transdate!=null" class="two-line">{{ new Date(item.transdate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) }}</p>
                            </template>
                            <template v-slot:item.transamount="{ item }">
                              <p v-if="item.transamount!=null" class="two-line">{{ item.transamount.toFixed(2) }}</p>
                            </template>
                          </v-data-table>
                        </v-col>
                      </v-row>
                    </v-tab-item>
                    <v-tab-item :value="'tab-files'" :key="3">
                      <FileView :id="initvalue._id" :route="`salesorder`" :files="files" :data="initvalue"/>
                    </v-tab-item>  
                  </v-tabs>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import FileView from "@/pages/File/Components/FileView.vue";

export default {
  name: "SalesOrderView",
  components: {
    FileView
  },
  data() {
    return {
      header_items: [
        { text: 'Image', value: 'itemimage', width: '5%' },
        { text: 'Name', value: 'itemname' },
        { text: 'Price ', value: 'itemprice', width: '8%'},
        { text: 'Foc ', value: 'itemfoc' },
        { text: 'Quantity ', value: 'itemquantity', width: '8%' },
        { text: 'Amount', value: 'itemamount', width: '8%' },
      ],
      header_deposits: [
        { text: 'Deposit Date', value: 'transdate', width: '12%' },  
        { text: 'Reference Num', value: 'refnum' },  
        { text: '', value: 'transdesc', width: '8%', align: 'right'},
        { text: 'Deposit Amount', value: 'transamount', width: '12%', align: 'right'},
      ],
      initvalue: {},
      transactions: [],
      deposits: [],
      files: [],
      images: [],
      itemPerPage: 500,
      footer: {'items-per-page-options': [500, 1000, 5000]},
      selected: [],
      showImageDialog: false,
      image: null,
    };
  },
  computed: {
    ...mapState('Account', ['accounts']),
    ...mapState('SalesOrder', ['isReceiving']),
    data_total(){
      let result = this.transactions.reduce(function (last, json) {return last + json.itemamount;}, 0);
      return result;
    },
    data_deposits(){
      let result = this.deposits.reduce(function (last, json) {return last + json.transamount;}, 0);
      return result;
    },
  },
  methods: {
    ...mapActions('Account', ["getAccountsRequest"]),
    ...mapActions('SalesOrder', ["getSalesOrderRequest"]),
    Done() {
      this.$router.replace({ name: 'SalesOrderList' });
    },
  },
  async created() {
    this.initvalue = this.$route.params;    
    if (!this.initvalue._id) this.$router.push({ name: "SalesOrderList" });

    let result = await this.getSalesOrderRequest(this.initvalue._id);
    this.transactions = Object.assign([], result.transactions);
    this.deposits = Object.assign([], result.deposits);
    this.files = Object.assign([], result.files);
    this.images = Object.assign([], result.images);

    if(this.accounts.length==0) await this.getAccountsRequest();
  },
};
</script>

<style src="./View.scss" lang="scss"/>
